// customIconPaths.js
// Custom single-path icons that are not in Material Symbols.
// Same contract as `_icons`: one filled `d` on viewBox `0 -960 960 960`.

export const AI_ICON_KEY = 'ai';

/** Outlined-400 weight "AI" monogram for 20–24px toolbar use. */
export const AI_ICON_PATH = 'M421-767L379-749L207-184L299-184L421-585ZM421-767L463-749L635-184L543-184L421-585ZM377-440L465-440L492-352L350-352ZM653-767h100v583h-100Z';
